import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { User } from "src/app/shared/models/User";
import { ApiService } from "src/app/shared/services/api.service";
import { LocalStorageServices } from "src/app/shared/services/local-storage.services";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private userSubject: BehaviorSubject<User>;
  public user$: Observable<User>;
  private _authenticated: boolean = false;

  constructor(
    private ls: LocalStorageServices,
    private http: HttpClient,
    private apiService: ApiService
  ) {
    this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('USER')));
    this.user$ = this.userSubject.asObservable();
  }

  //user service:
  set user(user: User) {
    this.ls.setItem('USER', user);
  }
  get user(): User {
    return this.ls.getItem('USER') ?? '';
  }
  //auth service:
  set accessToken(token: string) {
    this.ls.setItem('accessToken', token);
  }
  get accessToken(): string {
    return this.ls.getItem('accessToken') ?? '';
  }
  set expires_at(expires_at: number) {
    this.ls.setItem('expires_at', expires_at);
  }
  get expires_at(): number {
    return this.ls.getItem('expires_at') ?? '';
  }

  //current user
  public get userValue(): User {
    return this.userSubject.value;
  }

  public login(user) {

    let url = environment.apiUrl + 'token'
    let body = `username=${user.username}&password=${user.password}&grant_type=password`;
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.post<any>(url, body, options)
      .pipe(map(response => {
        // Store the access token in the local storage
        this.accessToken = response.access_token;
        // Set expiration date
        this.expires_at = this.setExpiration(response.expires_in);
        // console.log("Expire_at:"+this.expires_at);
        // console.log("Expire_at date:"+new Date(this.expires_at));
        // Set the authenticated flag to true
        this._authenticated = true;
        //console.log("login auth:" + this._authenticated);
        // Store the user on the user service
        this.user = user;
        this.userSubject.next(user);
        return user;
      }));
  }

  public logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('USER');
    localStorage.removeItem('expires_at');
    this._authenticated = false;
    this.userSubject.next(null);
  }

  // public isAuthenticated() : boolean{
  //     return false;
  // }

  public isExpired() {
    // console.log("expires_at: " + this.expires_at ? new Date(this.expires_at) : "null this.expires_at");
    // console.log("isExpired: " + (date.valueOf() > this.expires_at));
    if (this.expires_at) {
      let date = new Date();
      return (date.valueOf() > this.expires_at);
    }
    return true;
  }

  public refreshToken() {
    this.accessToken = null;
    this.expires_at = null;
    let body = `username=${this.user.username}&password=${this.user.password}&grant_type=password`;
    this.apiService.refreshToken(body).then((response) => {
      this.accessToken = response.access_token;
      this.expires_at = this.setExpiration(response.expires_in)
    });
  }

  public refreshTokenAsync(): Promise<any> {
    this.accessToken = null;
    this.expires_at = null;
    let body = `username=${this.user.username}&password=${this.user.password}&grant_type=password`;
    return this.apiService.refreshToken(body).then((response) => {
      this.accessToken = response.access_token;
      this.expires_at = this.setExpiration(response.expires_in)
    });
  }

  private setExpiration(expires_in) {
    const expiryDate = new Date();
    const ms = 1000;
    expiryDate.setTime(expiryDate.getTime() + (expires_in * ms));
    return expiryDate.valueOf();
  }

  isAuthenticated(): boolean {
    // console.log("token:",!!this.accessToken);
    // return Boolean(this.accessToken);
    // || null !== this.user.username || "" !== this.user.username.trim();
    return null !== this.accessToken && 0 < this.accessToken.length
  }
}